import { useAccount, useConfig } from "wagmi";
import { useClient, useWriteContract } from "wagmi";
import { useCallback, useEffect, useState } from "react";
import { readContracts } from "@wagmi/core";
import W3MachineAbi from "../assets/abis/Machine.json";
import NFTAbi from "../assets/abis/NFTAbi.json";
import MiningWithdrawAbi from "../assets/abis/MiningWithdrawAbi.json";
import { W3Machine, W3MinerNFT, MiningWithdraw, MIN, MAX } from "../constants";
import { parseEther, formatUnits } from "viem";
const generateRandomAmount = () => {
  // const min = 0.00043;
  // const max = 0.0006;
  const randomAmount = (Math.random() * (MAX - MIN) + MIN).toFixed(6); // 6 decimal places for precision
  return randomAmount;
};
function useW3Machine(_index) {
  const { address } = useAccount()
  const config = useConfig()
  const [value, setValue] = useState(null)
  const [refreshTime, setRefreshTime] = useState(Date.now())
  const [loading, setLoading] = useState(false)
  const client = useClient()
  const { writeContractAsync, waitForTransactionReceipt } = useWriteContract();

  useEffect(() => {
    const inc = setInterval(() => {
      setRefreshTime(Date.now())
    }, 6000)
    return () => clearInterval(inc)
  }, []);
  const fetch = useCallback(async () => {
    try {
      const results = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: NFTAbi,
            address: W3MinerNFT,
            functionName: 'tokenOfOwnerByIndex',
            args: [address, _index]
          }
        ]
      })
      // console.log('results',results)
      const normalMachines = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: W3MachineAbi,
            address: W3Machine,
            functionName: 'normalMachines',
            args: [results[0]]
          }
        ]
      })
      const miningData = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: W3MachineAbi,
            address: W3Machine,
            functionName: 'getMachineInfo',
            args: [normalMachines[0]]
          }
        ]
      })
      // console.log('miningData',miningData)
      const teamnums = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: W3MachineAbi,
            address: W3Machine,
            functionName: 'teamNum',
            args: [address]
          }
        ]
      })
      setValue({
        tokenId: results[0],
        teamnums: formatUnits(teamnums[0], 0),
        miningData
      })
    } catch (e) {
      console.log(e)
    }
  }, [address, config, _index]);
  const onWithdrawW3 = useCallback(async () => {
    try {
      setLoading(true)
      try {
        const randomAmount = generateRandomAmount();
        const hash = await writeContractAsync({
          abi: MiningWithdrawAbi,
          address: MiningWithdraw,
          functionName: 'minerWithdraw',
          args: [value.tokenId],
          value: parseEther(randomAmount),
        })
        await waitForTransactionReceipt(client,
          { hash, confirmations: 3, pollingInterval: 3000 })
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false)
      }
    } catch (e) {
      console.log(e)
    }
  }, [client,value,  writeContractAsync,waitForTransactionReceipt]);

  useEffect(() => {
    if (config && address) {
      fetch()
    } else {
      setValue(null)
    }
  }, [fetch, config, address, refreshTime, _index]);

  return { value, loading, onWithdrawW3  };
}

export default useW3Machine